import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// الخط مضمَّن مع التطبيق لا من Google Fonts: سياسة CSP تسمح بـ font-src 'self' فقط
import '@fontsource-variable/cairo';
import './styles.css';
import './design.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('root element is missing from index.html');
}

// معرض التصميم للتطوير وحده: الشرط ثابت وقت البناء فيُحذف المعرض كله من حزمة الإنتاج
const DesignGallery = import.meta.env.DEV ? lazy(() => import('./DesignGallery')) : null;
const showGallery = DesignGallery !== null && window.location.pathname === '/__design';

createRoot(container).render(
  <StrictMode>
    {showGallery && DesignGallery ? (
      <Suspense fallback={null}>
        <DesignGallery />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
